
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.25.03H.5a.5.5 0 00-.5.5v23a.5.5 0 00.5.5h5.75a.5.5 0 00.5-.5v-23a.5.5 0 00-.5-.5zM1 7.48l4.04 4.05H1zm4.75 3.34L1.71 6.78h4.04zM1 12.52h4.75v4.76H1zm0-11.5h4.75v4.76H1zm4.75 22H1v-4.74h4.75zm2.5-13.87a.5.5 0 00.04.2c0 .02.02.03.03.04a.53.53 0 00.08.12l.01.01 1.48 1.35a.5.5 0 10.67-.74l-.52-.48h4.7a.5.5 0 000-1h-4.7l.52-.48a.5.5 0 10-.67-.74L8.41 8.78l-.01.01a.53.53 0 00-.09.12l-.02.04a.5.5 0 00-.04.2zm14.72.06l-.25-.25a3.4 3.4 0 00-4.8 0l-4.48 4.48-3.07 3.07-1.4 1.4a3.4 3.4 0 000 4.8l.25.26a3.4 3.4 0 004.8 0l8.96-8.95a3.4 3.4 0 000-4.8zm-6.46 2.57l3.65 3.64-4.74 4.73-3.64-3.64 2.37-2.37zm-3.2 10.48a2.4 2.4 0 01-3.39 0l-.25-.25a2.4 2.4 0 010-3.39l1.4-1.4 3.64 3.64zm8.95-8.95l-1.4 1.4-3.64-3.64 1.4-1.4a2.4 2.4 0 013.4 0l.24.25a2.4 2.4 0 010 3.4z"}}),_c('path',{attrs:{"d":"M13.65 16.9a.39.39 0 100-.53.39.39 0 000 .54zm1.9-1.35a.38.38 0 10-.54 0 .38.38 0 00.54 0z"}}),_c('circle',{attrs:{"cx":"16.64","cy":"13.92","r":".39"}}),_c('path',{attrs:{"d":"M15.04 17.75a.39.39 0 10.54 0 .39.39 0 00-.54 0zm1.36-1.35a.39.39 0 10.54 0 .39.39 0 00-.54 0zm1.9-.82a.39.39 0 10-.54 0 .39.39 0 00.54 0z"}})])
          )
        }
      }
    